var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 26,
    viewBox: "0 0 12 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18363 7.59753L4.18363 19.8475C4.18363 20.3117 4.368 20.7568 4.69619 21.085C5.02437 21.4131 5.46949 21.5975 5.93361 21.5975C6.39773 21.5975 6.84285 21.4131 7.17104 21.085C7.49922 20.7568 7.68359 20.3117 7.68359 19.8475L7.68359 4.09753C7.68359 2.21206 6.11659 0.683594 4.18359 0.683593C2.2506 0.683593 0.683594 2.21206 0.683594 4.09753L0.683593 20.0656C0.683593 21.458 1.23672 22.7934 2.22128 23.7779C3.20585 24.7625 4.54121 25.3156 5.93359 25.3156C7.32598 25.3156 8.66134 24.7625 9.6459 23.7779C10.6305 22.7934 11.1836 21.458 11.1836 20.0656L11.1836 7.81564",
    stroke: "#32A05F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttach);
export default __webpack_public_path__ + "static/media/fileAttach.1bb3c2032e9c872ab653c51294807eba.svg";
export { ForwardRef as ReactComponent };